export default __webpack_public_path__ + "static/media/scooter.1443dbd2.svg";